<script>
import {
  loadKitItems as loadKitItemsApi,
  deleteKitItem as deleteKitItemApi
} from "@/api/store/ProductsService.js";
import NewKitProductModal from "./NewKitProductModal.vue";
import EditKitProductModal from "./EditKitProductModal.vue";
export default {
  components: {
    NewKitProductModal,
    EditKitProductModal
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      kit: null,
      showNewItemModal: false,
      editingProduct: null
    };
  },
  mounted() {
    this.loadKitItems();
  },
  methods: {
    loadKitItems() {
      this.loading = true;
      loadKitItemsApi(this.code)
        .then(response => {
          this.kit = response;
        })
        .catch(() => {
          this.$toast.open({
            message: `Error loading kit items`,
            type: "error",
            position: "top-right"
          });
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteKitItem(itemCode) {
      deleteKitItemApi(this.code, itemCode)
        .then(() => {
          this.$toast.open({
            message: `The kit item ${itemCode} was deleted`,
            type: "success",
            position: "top-right"
          });
          this.loadKitItems();
          this.$emit("kitUpdated");
        })
        .catch(() => {
          this.$toast.open({
            message: `Error deleting kit item ${itemCode}`,
            type: "error",
            position: "top-right"
          });
        });
    },
    kitItemAdded() {
      this.showNewItemModal = false;
      this.loadKitItems();
      this.$emit("kitUpdated");
    },
    kitItemUpddated() {
      this.editingProduct = null;
      this.loadKitItems();
      this.$emit("kitUpdated");
    },
    editKitItem(item) {
      this.editingProduct = item;
    }
  }
};
</script>
<template>
  <div class="content w-full">
    <div class="box full">
      <div class="box-header">
        Kit items
      </div>
      <div class="box-content-block pt-4 relative flex flex-col">
        <div class="w-full flex flex-row flex-end justify-end mb-2">
          <button class="btn btn-info-button" @click="showNewItemModal = true">
            Add product
          </button>
          <EditKitProductModal
            v-if="editingProduct"
            :item="editingProduct"
            :kitCode="code"
            @kitItemUpddated="kitItemUpddated"
            @close="editingProduct = null"
          ></EditKitProductModal>
          <NewKitProductModal
            v-if="showNewItemModal"
            :kitCode="code"
            @kitItemAdded="kitItemAdded"
            @close="showNewItemModal = false"
          ></NewKitProductModal>
        </div>
        <div style="min-height: 200px;">
          <table v-if="kit?.items?.length > 0">
            <thead>
              <th class="w-28"></th>
              <th>
                NKR code
              </th>
              <th>
                Info
              </th>
              <th>
                Quantity
              </th>
              <th>
                Discount settings
              </th>
              <th>
                Pricing and stock
              </th>
              <th>
                Actions
              </th>
            </thead>
            <tbody>
              <tr v-for="item in kit.items" :key="item.nkrCode">
                <td>
                  <img
                    :src="item.imageRoute"
                    :alt="item.nkrCode"
                    class="w-full"
                  />
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'ProductPage',
                      params: {
                        productCode: item.nkrCode
                      }
                    }"
                    target="_blank"
                    class="text-blue-500"
                  >
                    {{ item.nkrCode }}
                  </router-link>
                </td>
                <td>
                  {{ item.name }}
                  <br />
                  Brand: {{ item.brand }}
                </td>
                <td>
                  {{ item.quantity }}
                </td>
                <td>
                  <p>
                    Price type: <b>{{ item.priceType }}</b>
                  </p>
                  <p>
                    Discount type: <b>{{ item.productDiscountType }}</b>
                  </p>
                  <p>
                    Discount: <b>{{ item.productDiscountValue }}</b>
                  </p>
                  <p>
                    Stock: <b>{{ item.stock }}</b>
                  </p>
                </td>
                <td>
                  <p>Online price: ${{ item.onlinePrice }}</p>
                  <p class="font-bold">Discounted price: ${{ item.price }}</p>
                </td>
                <td>
                  <div class="flex flex-row">
                    <a @click="editKitItem(item)" class="icon">
                      <img src="@/assets/icons/edit.svg" />
                    </a>
                    <a class="icon" @click="deleteKitItem(item.nkrCode)">
                      <img src="@/assets/icons/trash.svg" />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <div v-if="loading">
              <BaseLoading :loading="true"></BaseLoading>
            </div>
            <div v-else-if="error">
              <BaseError></BaseError>
            </div>
            <div
              v-else-if="kit?.items?.length == 0"
              class="bg-red-200 p-10 text-white text-red-500 font-bold text-center"
            >
              No kit items found
            </div>
          </div>
        </div>
        <div
          v-if="kit"
          class="py-4 bg-gray-500 my-2 px-2 text-white text-xl justify-end flex"
        >
          Original price ${{ kit.priceNoDiscount }},<b class="ml-4"
            >Total discounted kit
            <span class="text-green-500 font-bold">${{ kit.price }}</span></b
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead th {
  text-align: left;
  padding: 0.5rem;
}
table,
td,
th {
  border: 1px solid black;
}
table tbody td {
  padding: 0.5rem;
  vertical-align: top;
}
.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $M8;
  border-radius: 10px;
  padding: 5px;
  width: 30px;
  margin-left: 5px;
  &:hover {
    background-color: $M8;
  }
  img {
    width: 100%;
  }
}
</style>
